import React, { Component } from 'react';
import { format } from 'd3-format';
import moment from 'moment';
import 'moment/locale/ko';
import 'moment/locale/ja';
import i18next from './LocalizedStrings';
import { unit } from './Currency'
import { storeBadge } from '../asset/image/store_badge'

moment.locale(i18next.language);

export function getPercentString(value, decimal) {

    if (value * 100 > 1000) {
        return getStringNumber(value * 100) + "%"

    } else {
        const size = decimal || 0;
        return format('.' + size + '%')(value);
    }
}

export function getDateString(timeStamp) {

    return moment(timeStamp).format('ll');
}

function getStringNumber(value) {
    const lang = i18next.getLanguage()

    if (lang === 'ko' || lang === 'ja') {
        let cutValue = Math.round(value / 10000000)
        if (cutValue < 1) {
            if (value > 100000) {
                cutValue = Math.round(value / 10000)
                const surfix = lang === 'ko' ? '만' : '万'
                return format(",.2r")(cutValue) + surfix
            }

            return format(",.2r")(value)
        }

        const arr = cutValue.toString().split('')
        const lastNum = arr.pop()
        const size = arr.length

        let numberString = ''
        if (lastNum != '0' && size <= 4) {
            numberString = lastNum + (lang == 'ko' ? '천만' : '千万')
        }

        const _unit = lang == 'ko' ? unit.ko : unit.jp

        for (var i = 0; i < size; i++) {
            const num = arr.pop()
            if (i % 4 == 0) {
                numberString = num + _unit[i / 4] + ' ' + numberString
            } else {
                numberString = num + numberString
            }
        }

        return numberString
    } else {
        const min = min || 1e3;
        // Alter numbers larger than 1k
        if (value >= min) {
            var units = ["k", "M", "B", "T"];

            var order = Math.floor(Math.log(value) / Math.log(1000));
            var unitname = units[(order - 1)];
            var num = Math.floor(value / 1000 ** order);

            return format(",.2r")(num) + unitname
        }

        return format(",.2r")(value)
    }
}

export function getStoreBadge(theme, width) {
    const appstoreSize = width > 450 ? 56 : 28
    const appstorePadding = width > 450 ? 12 : 6
    const playstoreSize = width > 450 ? 80 : 40

    return (
        <div style={{ marginTop: '0.5em' }}>
            <a href='https://itunes.apple.com/app/id1572464401'>
                <img style={{ padding: appstorePadding }} height={appstoreSize} src={storeBadge[theme.themeName].appstore[i18next.getLanguage()]} />
            </a>
            <a href='https://play.google.com/store/apps/details?id=com.caminogames.traders'>
                <img height={playstoreSize} src={storeBadge[theme.themeName].playstore[i18next.getLanguage()]} />
            </a>
        </div>

    )
}